import { addLanguageChangeReset } from "domains/language/reducerHelpers";
import { addUserChangeReset } from "entities/user/utils";

export const addUserOrLanguageChangeReset = <T, A extends { type: string }>(
  reducer: (state: T, action: A) => T,
  initialState: T,
) => addLanguageChangeReset(addUserChangeReset(reducer, initialState), initialState);
